var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-map" },
    [
      _c("div", { ref: "map", staticClass: "global-map__map" }, [
        _vm.showMapGuard
          ? _c("div", { staticClass: "embedguard" }, [
              _c("div", { staticClass: "embedguard__content" }, [
                _c("h3", {
                  domProps: { innerHTML: _vm._s(_vm.guardHeadline) },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "ignore-dependencies",
                  domProps: { innerHTML: _vm._s(_vm.guardIntro) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { staticClass: "input checkbox checkbox--switch" },
                    [
                      _c("div", { staticClass: "form-check" }, [
                        _c(
                          "label",
                          { staticClass: "add-on form-check-label" },
                          [
                            _c("input", {
                              ref: "checkbox",
                              attrs: { type: "checkbox" },
                              on: { change: _vm.acceptConsent },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.guardLabel) },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("global-info-dealer", {
        ref: "infoWindowDealer",
        staticClass: "global-info--map-reference",
        on: {
          choose: function ($event) {
            return _vm.dealerChosen($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }